import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ServicesModule } from './services/services.module';

// Material Imports
import {
  MatSelectModule,
  MatSortModule,
  MatRadioButton,
  MatRadioModule,
  MatStepperModule
} from '@angular/material';
import {
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatInputModule
} from '@angular/material';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// ANIMATIONS
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalCrearNombreComponent } from './components/modal-crear-nombre/modal-crear-nombre.component';
import { ModalEditarNombreComponent } from './components/modal-editar-nombre/modal-editar-nombre.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalErrorLoginComponent } from './components/modal-error-login/modal-error-login.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalDescargaDatosPublicoComponent } from './components/modal-descarga-datos/modal-descarga-datos-publico.component';
import { ModalDescargaDatosEmpresaComponent } from './components/modal-descarga-datos/modal-descarga-datos-empresa.component';
import { ModalDescargaDatosCoordinadorComponent } from './components/modal-descarga-datos/modal-descarga-datos-coordinador.component';
import { PipesModule } from './pipes/pipes.module';
import { ModalNoSesionComponent } from './components/modal-no-sesion/modal-error-no-sesion.component';
import { ModalConfirmacionComponent } from './components/modal-confirmacion/modal-confirmacion.component';
import {NgxCaptchaModule} from 'ngx-captcha';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ModalCrearNombreComponent,
    ModalEditarNombreComponent,
    ModalErrorLoginComponent,
    LoadingComponent,
    ModalDescargaDatosPublicoComponent,
    ModalDescargaDatosCoordinadorComponent,
    ModalDescargaDatosEmpresaComponent,
    ModalNoSesionComponent,
    ModalConfirmacionComponent
  ],
  imports: [
    CommonModule,
    ServicesModule,
    // Material Modules
    MatSelectModule,
    MatStepperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatDialogModule,
    MatTooltipModule,
    MatGridListModule,
    MatRadioModule,
    BrowserAnimationsModule,
    FormsModule,
    MatSortModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    PipesModule,
    NgxCaptchaModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    // Material Modules
    LoadingComponent,
    MatSelectModule,
    MatDatepickerModule,
    MatStepperModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatListModule,
    MatMenuModule,
    MatRadioModule,
    MatPaginatorModule,
    MatDialogModule,
    MatTooltipModule,
    MatGridListModule,
    BrowserAnimationsModule,
    ModalCrearNombreComponent,
    ModalEditarNombreComponent,
    NgxMatSelectSearchModule
  ],
  entryComponents: [
    ModalErrorLoginComponent,
    ModalDescargaDatosPublicoComponent,
    ModalDescargaDatosCoordinadorComponent,
    ModalDescargaDatosEmpresaComponent,
    ModalNoSesionComponent,
    ModalConfirmacionComponent
  ]
})
export class SharedModule {}
